import React from 'react';
import Friends from '../components/Friends';
import { useAuth } from '../contexts/AuthContext';

const FriendsPage: React.FC = () => {
  const { user } = useAuth();

  // Rendered inside a ProtectedRoute, so `user` is normally set; guard anyway.
  if (!user) return null;

  return <Friends currentUserId={user.id} />;
};

export default FriendsPage;
